import { StyleSheet } from 'aphrodite';
import theme from '~/src/theme';

export default StyleSheet.create({
  docSetContainer: {
    padding: theme.unit * 2,
    margin: '0 auto',
  },
  docImage: {
    background: 'white',
    width: '100%',
    maxWidth: '100%',
    marginBottom: theme.unit,
    ':last-of-type': {
      marginBottom: '0',
    },
  },
  imgSetTitle: {
    fontSize: theme.fonts.size.regular,
    textAlign: 'center',
    marginBottom: `${theme.unit * 4}px`,
  },
  imgSetContainer: {
    width: '100%',
    margin: '0 auto',
    marginBottom: `${theme.unit * 6}px`,
    ':first-of-type': {
      marginTop: `${theme.unit * 2}px`,
    },
    ':last-of-type': {
      marginBottom: '0',
    },
  },
  imgSetDivider: {
    height: '1px',
    width: '85%',
    margin: '0 auto',
    background: theme.colors.smoke,
    marginBottom: `${theme.unit * 2}px`,
    marginTop: `${theme.unit * 4}px`,
  },
  imgSetEmptyText: {
    lineHeight: '1.5em',
    fontSize: theme.fonts.size.small,
    textAlign: 'center',
    marginBottom: `${theme.unit * 2}px`,
  },
});
